webpackJsonp([110937214064242],{

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cancelation = function cancelation() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Cancellation Policy'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you need to cancel our appointment, please contact me at least 24 hours prior to our appointment. A $50 fee will be charged for appointments missed with less than 24 hours notice of cancellation.'
	    )
	  );
	};
	
	exports.default = cancelation;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cancelation-policy-js-c8efa4c9aa7074e63323.js